/* PWRRR Studio — product page behaviour. No dependencies. */
(function () {
  var money = function (pence) {
    return '£' + (pence / 100).toFixed(2);
  };
  var perDay = function (pence, days) {
    return '£' + (pence / 100 / days).toFixed(2) + ' per day';
  };
  /* Whole pounds drop the .00, matching money_without_trailing_zeros so the
     server-rendered unit price and the one JS writes over it are identical. */
  var unitMoney = function (pence) {
    var p = pence / 100;
    return '£' + (p % 1 === 0 ? p.toFixed(0) : p.toFixed(2));
  };
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------------------------------------------------------- buy box */
  function buyBox() {
    var data = $('[data-pdp-data]');
    var form = $('#buy-form');
    if (!data || !form) return;

    var D;
    try { D = JSON.parse(data.textContent); } catch (e) { return; }

    var variantInput = $('[data-variant-input]', form);
    var planInput = $('[data-plan-input]', form);
    var freqWrap = $('[data-freq]', form);
    var freqOpts = $('.freq__opts', form);
    var addTotal = $('[data-add-total]', form);
    var addLabel = $('[data-add-label]', form);
    var fine = $('[data-fine]', form);

    var state = { id: D.initial, mode: 'onetime', plan: null };

    var find = function (id) {
      for (var i = 0; i < D.variants.length; i++) if (D.variants[i].id === id) return D.variants[i];
      return D.variants[0];
    };

    function priceFor(v, mode, planId) {
      if (mode === 'sub' && v.plans.length) {
        for (var i = 0; i < v.plans.length; i++) if (v.plans[i].id === planId) return v.plans[i].price;
        return v.plans[0].price;
      }
      return v.onetime;
    }

    function renderFreq(v) {
      if (!freqWrap) return;
      if (state.mode !== 'sub' || !v.plans.length) { freqWrap.hidden = true; return; }
      freqWrap.hidden = false;
      freqOpts.innerHTML = '';
      v.plans.forEach(function (plan, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'freq' + ((state.plan === plan.id || (state.plan === null && i === 0)) ? ' is-on' : '');
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', b.className.indexOf('is-on') > -1 ? 'true' : 'false');
        b.textContent = plan.name || 'Every delivery';
        b.addEventListener('click', function () { state.plan = plan.id; render(); });
        freqOpts.appendChild(b);
      });
      if (state.plan === null) state.plan = v.plans[0].id;
    }

    /* Delivery cost in pence, by pack size rather than by cart value.
       The single pack pays; three and six do not, in either purchase mode.
       That is the intended ladder and it holds for every combination verified
       against live cart rates on 1 Aug 2026, with one exception: a single-pack
       subscription is currently also offered a £0.00 rate, because a
       subscription shipping rule overlaps the £49 threshold rule. Stating
       £3.99 there under-promises rather than over-promises, which is the safe
       direction — nobody is annoyed by cheaper-than-expected postage. */
    var SHIPPING_PENCE = 399;
    var FREE_FROM_PACKS = 3;
    function shippingCostFor(pv) {
      return pv.packs >= FREE_FROM_PACKS ? 0 : SHIPPING_PENCE;
    }

    /* Trade-up prompt, shown only when the current choice actually pays for
       delivery. Quotes the real saving and the real per-day difference so the
       customer can check the arithmetic themselves. */
    function renderNudge(v) {
      var el = $('[data-nudge]', form);
      if (!el) return;
      var txt = $('[data-nudge-text]', el);
      var pays = shippingCostFor(v, state.mode);
      if (!pays) { el.hidden = true; return; }

      // Smallest larger pack that gets delivery free, so the ask stays modest.
      var target = null;
      for (var i = 0; i < D.variants.length; i++) {
        var c = D.variants[i];
        if (c.packs > v.packs && !shippingCostFor(c, state.mode) && (!target || c.packs < target.packs)) target = c;
      }
      if (!target) { el.hidden = true; return; }

      /* Lead with the discount, not the per-day difference. Between a single
         and a three pack that difference is about 5p, which reads as a reason
         not to bother. The saving off list is the same comparison stated at a
         scale worth acting on, and it is the figure already printed on each
         pack row, so the customer can check it against the page. */
      var multiple = Math.round(target.days / v.days);
      var savingThere = Math.round((target.list - priceFor(target, state.mode, state.plan)) / 100);

      txt.textContent =
        'Go up to the ' + target.title + ': ' +
        (multiple > 1 ? multiple + '× the supply, ' : '') +
        '£' + savingThere + ' off and free delivery.';
      el.hidden = false;
      el.dataset.target = String(target.id);
    }

    function render() {
      var v = find(state.id);
      if (state.mode === 'sub' && v.plans.length) {
        var ok = false;
        v.plans.forEach(function (p) { if (p.id === state.plan) ok = true; });
        if (!ok) state.plan = v.plans[0].id;
      }

      $$('[data-pack]', form).forEach(function (btn) {
        var pv = find(parseInt(btn.dataset.variant, 10));
        var on = pv.id === state.id;
        btn.classList.toggle('is-on', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        var now = priceFor(pv, state.mode, state.plan);
        var np = $('[data-pack-price]', btn);
        var wa = $('[data-pack-was]', btn);
        var pe = $('[data-pack-per]', btn);
        var sv = $('[data-pack-save]', btn);
        if (np) np.textContent = money(now);
        if (wa) { wa.textContent = money(pv.list); wa.hidden = now >= pv.list; }
        if (pe) pe.textContent = perDay(now, pv.days);
        var un = $('[data-pack-unit]', btn);
        if (un) un.textContent = unitMoney(Math.round(now / pv.packs));
        if (sv) {
          var diff = pv.list - now;
          sv.textContent = 'Save ' + money(diff);
          sv.hidden = diff <= 0;
        }
        var sh = $('[data-pack-ship]', btn);
        if (sh) {
          var paysShipping = shippingCostFor(pv, state.mode);
          sh.textContent = paysShipping ? '+ ' + money(paysShipping) + ' delivery' : 'Free delivery';
          sh.classList.toggle('is-free', !paysShipping);
        }
      });

      renderNudge(v);

      $$('[data-mode]', form).forEach(function (btn) {
        var on = btn.dataset.mode === state.mode;
        btn.classList.toggle('is-on', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      $$('[data-mode-price]', form).forEach(function (el) {
        el.textContent = money(priceFor(v, el.dataset.modePrice, state.plan));
      });

      // Anchor the subscription against the one-off price for the same pack.
      var vs = $('[data-mode-vs]', form);
      if (vs) {
        var diff = v.onetime - priceFor(v, 'sub', state.plan);
        vs.textContent = diff > 0 ? money(diff) + ' less than one-off' : '';
      }

      renderFreq(v);

      variantInput.value = v.id;
      planInput.value = state.mode === 'sub' && v.plans.length ? state.plan : '';

      // Accelerated checkout cannot carry a selling_plan, so it only makes
      // sense on a one-time purchase.
      var express = $('[data-express]', form);
      if (express) express.hidden = state.mode === 'sub';

      var total = priceFor(v, state.mode, state.plan);
      if (addTotal) addTotal.textContent = money(total);

      var kl = $('[data-klarna-amount]');
      if (kl) kl.textContent = money(Math.round(total / 3));

      var sPrice = $('[data-stick-price]');
      var sWas = $('[data-stick-was]');
      var sImg = $('[data-stick-img]');
      var sLabel = $('[data-stick-label]');
      if (sPrice) sPrice.textContent = money(total);
      if (sWas) { sWas.textContent = money(v.list); sWas.hidden = total >= v.list; }
      if (sLabel) sLabel.textContent = state.mode === 'sub' ? 'Subscribe' : 'Add';
      if (sImg && D.packImages) {
        var src = D.packImages[String(v.packs)] || D.packImages.fallback;
        if (src && sImg.getAttribute('src') !== src) {
          sImg.setAttribute('src', src);
          sImg.setAttribute('alt', v.title + ' of PWRRR Beauty Collagen');
        }
      }
      if (addLabel) addLabel.textContent = state.mode === 'sub' ? 'Start subscription' : 'Add to cart';
      if (fine) {
        fine.textContent = state.mode === 'sub'
          ? v.days + '-day supply, delivered on repeat. Skip or cancel anytime.'
          : v.days + '-day supply. One-off order, no subscription.';
      }
    }

    $$('[data-pack]', form).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        state.id = parseInt(btn.dataset.variant, 10);
        render();
      });
    });
    $$('[data-mode]', form).forEach(function (btn) {
      btn.addEventListener('click', function () { state.mode = btn.dataset.mode; render(); });
    });

    // The nudge names a specific pack, so tapping it should select that pack
    // rather than leaving the customer to find it themselves.
    var nudgeBtn = $('[data-nudge]', form);
    if (nudgeBtn) {
      nudgeBtn.addEventListener('click', function () {
        var id = parseInt(nudgeBtn.dataset.target, 10);
        if (!id) return;
        state.id = id;
        render();
      });
    }

    // Sticky bar submits the real form rather than duplicating it, so there
    // is only ever one source of truth for variant and selling plan.
    var stick = $('[data-stick]');
    if (stick) {
      var addBtn = $('[data-stick-add]', stick);
      if (addBtn) {
        addBtn.addEventListener('click', function () {
          if (form.requestSubmit) form.requestSubmit();
          else form.submit();
        });
      }
      var anchor = $('[data-add]', form);
      if (anchor && 'IntersectionObserver' in window) {
        stick.hidden = false;
        var so = new IntersectionObserver(function (es) {
          es.forEach(function (e) { stick.classList.toggle('is-up', !e.isIntersecting); });
        }, { rootMargin: '0px 0px -40px 0px', threshold: 0 });
        so.observe(anchor);
      }
    }

    render();
  }

  /* ---------------------------------------------------------- gallery */
  function gallery() {
    var gal = $('[data-gallery]');
    if (!gal) return;
    var slides = $$('[data-slide]', gal);
    var marks = $$('[data-dot]');
    var prev = $('[data-gal-prev]');
    var next = $('[data-gal-next]');
    if (!slides.length) return;
    var at = 0;

    function sync(i) {
      at = i;
      marks.forEach(function (t) {
        var on = parseInt(t.dataset.dot, 10) === i;
        t.classList.toggle('is-on', on);
        if (t.hasAttribute('role')) t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      gal.scrollTo({ left: slides[i].offsetLeft - gal.offsetLeft, behavior: 'smooth' });
      sync(i);
    }

    marks.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.dataset.dot, 10)); });
    });
    if (prev) prev.addEventListener('click', function () { go(at - 1); });
    if (next) next.addEventListener('click', function () { go(at + 1); });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) sync(slides.indexOf(e.target)); });
      }, { root: gal, threshold: 0.6 });
      slides.forEach(function (sl) { io.observe(sl); });
    }
    sync(0);
  }

  /* ------------------------------------------------ horizontal rails */
  function rails() {
    $$('[data-rail]').forEach(function (rail) {
      var track = $('[data-rail-track]', rail);
      var prev = $('[data-rail-prev]', rail);
      var next = $('[data-rail-next]', rail);
      if (!track) return;

      function step() {
        var card = track.firstElementChild;
        return card ? card.getBoundingClientRect().width + 16 : 320;
      }
      function update() {
        if (!prev || !next) return;
        prev.disabled = track.scrollLeft < 8;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      update();
    });
  }

  /* ----------------------------------------------------------- reveal */
  function reveal() {
    var els = $$('.rv:not(.in)');
    if (!els.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ------------------------------------------------------------- tabs */
  function tabs() {
    $$('[data-tabs]').forEach(function (box) {
      var btns = $$('[data-tab]', box);
      var panels = $$('[data-panel]', box);
      if (!btns.length) return;

      function show(btn, focus) {
        var key = btn.dataset.tab;
        btns.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
        });
        panels.forEach(function (pn) { pn.hidden = pn.dataset.panel !== key; });
        if (focus) btn.focus();
      }

      btns.forEach(function (btn, i) {
        btn.addEventListener('click', function () { show(btn, false); });
        btn.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = btns[(i + 1) % btns.length];
          if (e.key === 'ArrowLeft') next = btns[(i - 1 + btns.length) % btns.length];
          if (e.key === 'Home') next = btns[0];
          if (e.key === 'End') next = btns[btns.length - 1];
          if (!next) return;
          e.preventDefault();
          show(next, true);
        });
      });
    });
  }

  /* ----------------------------------------------------------- videos */
  function videos() {
    var all = $$('[data-vid]');
    if (!all.length) return;

    function stopOthers(except) {
      all.forEach(function (v) {
        if (v === except) return;
        var el = $('.vid__el', v);
        if (el) {
          el._pwrrrPlaybackToken = Number(el._pwrrrPlaybackToken || 0) + 1;
          if (!el.paused) el.pause();
        }
        v.classList.remove('is-playing');
      });
    }

    all.forEach(function (card) {
      var el = $('.vid__el', card);
      var toggle = $('[data-vid-toggle]', card);
      var sound = $('[data-vid-sound]', card);
      if (!el || !toggle) return;

      function play(muted) {
        ensureSource();
        stopOthers(card);
        var playToken = Number(el._pwrrrPlaybackToken || 0) + 1;
        el._pwrrrPlaybackToken = playToken;
        el.muted = muted;
        card.classList.toggle('is-unmuted', !muted);
        if (sound) {
          sound.hidden = false;
          sound.setAttribute('aria-label', muted ? 'Unmute' : 'Mute');
        }
        var p = el.play();
        if (p && p.then) {
          p.then(function () {
            if (el._pwrrrPlaybackToken !== playToken) el.pause();
          }, function () {
            // Safari can reject an audible start despite a user tap. Retry muted
            // once, which is supported across mobile browsers and keeps the clip usable.
            if (!muted && el._pwrrrPlaybackToken === playToken) play(true);
          });
        }
      }

      /* The source is attached on first play, not at page load — that is what
         keeps nine HD clips off the critical path. */
      function ensureSource() {
        if (el.dataset.src && !el.querySelector('source')) {
          var sr = document.createElement('source');
          sr.src = el.dataset.src;
          sr.type = 'video/mp4';
          el.appendChild(sr);
          el.load();
        }
      }

      toggle.addEventListener('click', function () {
        if (el.paused) {
          ensureSource();
          play(false);
        } else {
          el._pwrrrPlaybackToken = Number(el._pwrrrPlaybackToken || 0) + 1;
          el.pause();
        }
      });
      el.addEventListener('play', function () { card.classList.add('is-playing'); toggle.setAttribute('aria-label', 'Pause video'); });
      el.addEventListener('pause', function () { card.classList.remove('is-playing'); toggle.setAttribute('aria-label', 'Play video'); });
      el.addEventListener('canplay', function () { card.classList.add('is-ready'); });
      el.addEventListener('error', function () {
        card.classList.add('is-unavailable');
        toggle.disabled = true;
        toggle.setAttribute('aria-label', 'Video unavailable');
      });

      if (sound) {
        sound.addEventListener('click', function (e) {
          e.stopPropagation();
          el.muted = !el.muted;
          card.classList.toggle('is-unmuted', !el.muted);
          sound.setAttribute('aria-label', el.muted ? 'Unmute' : 'Mute');
        });
      }
    });

    // stop playback when a clip scrolls away
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) return;
          var el = $('.vid__el', e.target);
          if (el && !el.paused) el.pause();
        });
      }, { threshold: 0.25 });
      all.forEach(function (v) { io.observe(v); });
    }
  }

  /* ------------------------------------------------- auto-scrolling rail */
  /* Drifts sideways on its own while the section is on screen, then hands
     control over permanently the moment the customer touches it — after that
     it is an ordinary scroller they drag themselves.

     The loop is seamless because the tiles are cloned once, so the track is
     exactly twice its real width: when the drift passes the halfway mark the
     position is rewound by half and the same pixels are already there. */
  function autoRail() {
    $$('[data-autorail]').forEach(function (rail) {
      var track = $('[data-ig-track]', rail);
      if (!track) return;

      // `init` runs again on shopify:section:load, and cloning twice would
      // break the exact-half arithmetic the seamless wrap depends on.
      if (rail.dataset.autorailReady) return;
      rail.dataset.autorailReady = '1';

      var originals = $$('li', track);
      if (originals.length < 2) return;

      var slow = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // Clone for the wrap. aria-hidden so the feed is announced once.
      var firstClone = null;
      originals.forEach(function (li) {
        var copy = li.cloneNode(true);
        copy.setAttribute('aria-hidden', 'true');
        $$('a', copy).forEach(function (a) { a.tabIndex = -1; });
        track.appendChild(copy);
        if (!firstClone) firstClone = copy;
      });

      var auto = !slow;
      var visible = false;
      var frame = null;
      var last = 0;
      var pxPerSecond = parseFloat(rail.dataset.speed) || 26;

      // The wrap point is where the first clone sits, not scrollWidth/2. Those
      // differ by half a gap — the track has 2n-1 gaps across 2n tiles, so half
      // the width lands mid-gap. Rewinding by that instead would nudge the strip
      // a couple of pixels out of alignment on every single loop, and the error
      // accumulates. Measured live because it changes with viewport width.
      function period() { return firstClone.offsetLeft - originals[0].offsetLeft; }

      function step(now) {
        frame = null;
        if (!auto || !visible) return;

        var dt = last ? Math.min((now - last) / 1000, 0.05) : 0;
        last = now;
        track.scrollLeft += pxPerSecond * dt;
        var p = period();
        if (p > 0 && track.scrollLeft >= p) track.scrollLeft -= p;

        frame = window.requestAnimationFrame(step);
      }

      function start() {
        if (frame || !auto || !visible) return;
        last = 0;
        frame = window.requestAnimationFrame(step);
      }
      function stop() {
        if (frame) window.cancelAnimationFrame(frame);
        frame = null;
      }

      // Hand over for good. Keep the scroll position exactly where the drift
      // left it so nothing jumps under the finger.
      function release() {
        if (!auto) return;
        auto = false;
        stop();
        rail.classList.add('is-manual');
      }

      ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (evt) {
        track.addEventListener(evt, release, { passive: true });
      });
      // A drag on the track fires scroll without any of the above on some
      // browsers, so treat a scroll the drift did not cause as a handover too.
      track.addEventListener('scroll', function () {
        if (auto && !frame) release();
      }, { passive: true });

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            visible = e.isIntersecting;
            if (visible) start(); else stop();
          });
        }, { threshold: 0.15 });
        io.observe(rail);
      } else {
        visible = true;
        start();
      }

      // Nothing should keep animating in a background tab.
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else start();
      });

      var prev = $('[data-autorail-prev]', rail);
      var next = $('[data-autorail-next]', rail);
      function nudge(dir) {
        release();
        var card = track.firstElementChild;
        var w = card ? card.getBoundingClientRect().width + 4 : 300;
        track.scrollBy({ left: dir * w * 2, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { nudge(-1); });
      if (next) next.addEventListener('click', function () { nudge(1); });
    });
  }

  /* ------------------------------------------------------- footer groups */
  /* The groups ship open, so without JavaScript the whole footer — policies
     included — stays readable. This only collapses them on narrow screens. */
  function footerGroups() {
    var groups = $$('[data-ft-group]');
    if (!groups.length) return;

    var wide = window.matchMedia('(min-width: 861px)');

    function sync() {
      groups.forEach(function (g) {
        if (wide.matches) {
          g.open = true;
          // Nothing to toggle on desktop: the summary is a heading there.
          g.setAttribute('data-static', '');
        } else {
          g.removeAttribute('data-static');
          // Only force-close on the first narrow pass, or reopening would fight
          // a customer who has just opened one.
          if (!g.dataset.touched) g.open = false;
        }
      });
    }

    groups.forEach(function (g) {
      g.addEventListener('toggle', function () {
        if (!wide.matches) g.dataset.touched = '1';
      });
      var s = $('summary', g);
      if (s) {
        s.addEventListener('click', function (e) {
          // On desktop the summary is decoration; clicking it should not close
          // a column the layout depends on being open.
          if (wide.matches) e.preventDefault();
        });
      }
    });

    sync();
    if (wide.addEventListener) wide.addEventListener('change', sync);
    else if (wide.addListener) wide.addListener(sync);
  }

  function init() { buyBox(); gallery(); rails(); autoRail(); tabs(); videos(); footerGroups(); reveal(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

/* ---------------------------------------------------------------- dispatch --
   The countdown never stops. It always targets the NEXT 4pm cut-off, so there
   is no closed state to design around and no moment where the box goes quiet:
   at 16:01 on Monday it simply flips to counting toward Tuesday's cut-off, and
   at midnight it is already counting toward the same day's.

   The label says what that cut-off buys — same-day dispatch, tomorrow, or the
   named weekday — so the number is never ambiguous.

   Arithmetic runs in Europe/London whatever the visitor's clock says, because
   the warehouse cut-off is a UK fact. */
(function () {
  var box = document.querySelector('[data-ship]');
  if (!box) return;
  var main = box.querySelector('[data-ship-main]');
  var sub = box.querySelector('[data-ship-sub]');
  var CUTOFF = Number(box.dataset.cutoffHour || 16);
  var MIN = Number(box.dataset.min || 2);
  var MAX = Number(box.dataset.max || 4);

  function ukNow() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/London' }));
  }
  function isWorkday(d) { var g = d.getDay(); return g > 0 && g < 6; }
  function addWorkdays(d, n) {
    var o = new Date(d);
    while (n > 0) { o.setDate(o.getDate() + 1); if (isWorkday(o)) n--; }
    return o;
  }
  /** The next moment an order can still make a dispatch: today's cut-off if it
   *  is a workday and we are before it, otherwise the next workday's. */
  function nextCutoff(now) {
    var c = new Date(now);
    c.setHours(CUTOFF, 0, 0, 0);
    if (isWorkday(now) && now < c) return c;
    do { c.setDate(c.getDate() + 1); } while (!isWorkday(c));
    c.setHours(CUTOFF, 0, 0, 0);
    return c;
  }
  /** Seconds are always shown inside 48 hours — that is every weekday case, and
   *  a ticking second is what makes the number read as live rather than static.
   *  Past 48 hours (only ever a weekend) it switches to days, because
   *  "71 hrs 12 mins 09 secs" is noise, not urgency. */
  function human(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    var d = Math.floor(s / 86400);
    var h = Math.floor((s % 86400) / 3600);
    var m = Math.floor((s % 3600) / 60);
    var sec = s % 60;
    var pad = function (n) { return n < 10 ? '0' + n : String(n); };
    if (d >= 2) return d + ' days ' + h + (h === 1 ? ' hr ' : ' hrs ') + m + (m === 1 ? ' min' : ' mins');
    var hrs = d * 24 + h;
    if (hrs > 0) return hrs + (hrs === 1 ? ' hr ' : ' hrs ') + m + (m === 1 ? ' min ' : ' mins ') + pad(sec) + ' secs';
    if (m > 0) return m + (m === 1 ? ' min ' : ' mins ') + pad(sec) + ' secs';
    return sec + ' secs';
  }
  function dayLabel(now, cut) {
    var a = new Date(now); a.setHours(0, 0, 0, 0);
    var b = new Date(cut); b.setHours(0, 0, 0, 0);
    var diff = Math.round((b - a) / 86400000);
    if (diff === 0) return 'same-day dispatch';
    if (diff === 1) return 'dispatch tomorrow';
    return 'dispatch ' + cut.toLocaleDateString('en-GB', { weekday: 'long' });
  }
  var short = function (d) { return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }); };

  function paint() {
    var now = ukNow();
    var cut = nextCutoff(now);
    var label = dayLabel(now, cut);
    main.innerHTML = 'Order in the next <strong class="buy__ship-clock">' + human(cut - now) +
      '</strong> for <strong>' + label + '</strong>';
    if (sub) {
      sub.textContent = 'Royal Mail Tracked 48 · arrives ' +
        short(addWorkdays(cut, MIN)) + '–' + short(addWorkdays(cut, MAX));
    }
  }

  paint();
  setInterval(paint, 1000);
})();
